export default "__VITE_ASSET__3zvC6_75__"